export const drawerWidth = 240;
export const appBarHeightLarge = 64;
export const appBarHeightSmall = 54;

const styles = theme => ({
    root: {
        background: theme.palette.background.default
    },
    progressDialog: {
        overflow: 'hidden',
        zIndex: 99999999
    },
    grow: {
        flexGrow: 1
    },
    drawerPaper: {
        position: 'relative',
        whiteSpace: 'nowrap',
        width: drawerWidth,
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    drawerPaperClose: {
        overflowX: 'hidden',
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        width: theme.spacing(7),
        [theme.breakpoints.up('sm')]: {
            width: theme.spacing(9),
        },
    },
    appBarSpacer: theme.mixins.toolbar,
    content: {
        flexGrow: 1,
        overflow: 'auto',
        marginTop: 120,
        padding: 0,
        '@media (max-width:767px)': {
            marginTop: 56,
        }
    }
});

export default styles;